<!-- Translated: yes -->
<template>
  <div class="center component">
    <h1>Tack för din betalning!</h1>
    <p></p>
    <p>&nbsp;</p>
    <p>&nbsp;</p>
    <p>Ditt bokningsnummer:</p>
    <p><b style="font-size:1.5em;">{{ reservationNumber }}</b></p>
    <p>&nbsp;</p>
    <p>Betalmetod:</p>
    <p><b style="font-size:1.5em;">{{ paymentMethod }}</b></p>
    <p>&nbsp;</p>
    <p>Summa:</p>
    <p><b style="font-size:1.5em;">{{paymentAmount | currency}}</b></p>
  </div>
</template>

<script>
export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      reservationNumber: null,
      customerNumber: null,
      paymentReference: null,
      paymentMethod: null,
      paymentAmount: null,
      paymentConfirmed: null,
    };
  },
  mounted() {
    this.reservationNumber = this.$route.query.booking;
    this.customerNumber = this.$route.query.customer;
    this.paymentReference = this.$route.query.reference;
    this.paymentMethod = this.$route.query.method;
    this.paymentAmount = this.$route.query.paidamount;
    this.paymentConfirmed = this.$route.query.confirmed;
  },
  methods: {
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.component
  padding-top 75px
</style>



// WEBPACK FOOTER //
// PayedExternally.vue?081bf814